'use client';

import Image from 'next/image';

import { openResponsiveDialog } from '@/stores/DrawerStore';

import { KosafHouseholdConsentContent } from './KosafHouseholdConsentContent';

export interface ShortcutActionRowProps {
  label: string;
  iconSrc: string;
  onNavigate?: () => void;
}

export const KosafHouseholdShortcutRow = ({
  label,
  iconSrc,
  onNavigate,
}: ShortcutActionRowProps) => {
  //* 메뉴 닫고 개인정보 제3자 제공 동의 화면을 ResponsiveDialog로 띄움. 동의 버튼 클릭 시 kosaf 링크 조회 + 리다이렉트.
  const handleClick = () => {
    onNavigate?.();
    openResponsiveDialog({
      component: KosafHouseholdConsentContent,
      modalHeader: '가구원 동의',
      drawerType: 'full',
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="flex w-full items-center gap-8 px-20 py-12 text-left transition-colors hover:bg-Gray-50"
    >
      <Image
        src={iconSrc}
        alt=""
        width={24}
        height={24}
        unoptimized
        className="size-24 shrink-0"
      />
      <span className="line-clamp-1 font-500 text-Gray-900 typo-body3">
        {label}
      </span>
    </button>
  );
};
